import type { CanalDeAcesso } from '@orbind/core'
import { ehAparelhoMovel } from '../shell/compacto.ts'
import { isDesktop } from './platform.ts'

/**
 * Por qual canal ESTE bundle está sendo usado (SPEC-20261008-1104-canais-de-acesso).
 *
 * - dentro do app instalado (Tauri) = desktop;
 * - celular ou tablet, pelo navegador do aparelho = celular — a regra é sobre
 *   o APARELHO, mesmo critério do layout mobile (compacto.ts);
 * - o resto = navegador do computador.
 */
export function canalAtual(): CanalDeAcesso {
  if (isDesktop()) return 'desktop'
  if (typeof navigator === 'undefined') return 'navegador'
  const nav = navigator as Navigator & { userAgentData?: { mobile?: boolean } }
  return ehAparelhoMovel(nav.userAgent, nav.maxTouchPoints ?? 0, nav.userAgentData) ? 'celular' : 'navegador'
}
